export const personalInfo = {
  name: "Usman Mahmood",
  title: "Senior AI Automation Engineer",
  roles: ["AI Automation Engineer", "LLM Integration Expert", "Voice AI Developer", "AWS Solutions Architect"],
  bio: "As a Senior AI Automation Engineer with over 3 years of enterprise experience, I specialize in architecting intelligent systems, LLM-driven workflows, and voice AI agents. My expertise spans building self-learning pipelines and multi-cloud integrations across AWS and Azure that transform complex challenges into scalable automation. From deploying robust RAG architectures to optimizing contact center AI, I deliver production-grade innovations that drive measurable business impact.",
  email: "contact@usmanmahmood.tech",
  github: "https://github.com/usmanX191",
  linkedin: "https://linkedin.com/in/usman-mahmood-1b54851a0",
  resume: "https://drive.google.com/file/d/1hLYh4zw0S5g73MR5xWQXBPnIRGnQyLEK/view?usp=sharing",
  stats: [
    { value: "30+", label: "Projects" },
    { value: "3+", label: "Years Exp" },
    { value: "100%", label: "Client Satisfaction" }
  ]
};

export const skills = {
  "AI / LLM Systems": ["OpenAI GPT-4o", "Claude", "Gemini", "LangChain", "LangGraph", "CrewAI", "AutoGen", "Amazon Bedrock", "Hugging Face", "RAG", "MCP Servers", "Prompt Engineering"],
  "Voice AI": ["VAPI", "ElevenLabs", "Twilio", "Amazon Lex", "Amazon Polly", "Amazon Transcribe", "Deepgram", "Whisper", "LiveKit"],
  "Automation & No-Code": ["n8n", "Make.com", "Power Automate", "Power Apps", "Copilot Studio", "Azure Logic Apps", "Zapier", "Pipedream"],
  "Cloud & DevOps": ["AWS", "Azure", "Docker", "Kubernetes", "GitHub Actions", "Nginx"],
  "Languages & Backend": ["Python", "FastAPI", "Node.js", "TypeScript", "JavaScript", "Flask", "Django", "Express.js", "GraphQL"],
  "Databases & Vector": ["PostgreSQL", "MongoDB", "Redis", "Pinecone", "Weaviate", "Qdrant", "ChromaDB", "DynamoDB", "Supabase"],
  "CRM & Integrations": ["HubSpot", "Salesforce", "GoHighLevel", "Zoho", "Apollo.io", "Stripe", "Twilio", "SendGrid"],
  "ML & Data": ["TensorFlow", "PyTorch", "Scikit-Learn", "Pandas", "NumPy", "Apache Kafka", "Apache Spark", "Power BI"]
};

export const projects = [
  {
    title: "AI Powered IVR System",
    category: "Voice AI",
    date: "March 2026",
    description: "Production grade enterprise AI voice calling agent cutting turn latency from 35 to 45s to 2 to 3s via live streaming and persistent KVS sessions.",
    tech: ["AWS Connect", "Amazon Bedrock", "Nova 2", "KVS", "Lambda", "Node.js", "Docker"],
    github: "",
    live: ""
  },
  {
    title: "CopeCart Lead Qualification System",
    category: "Sales Automation",
    date: "Nov to Dec 2025",
    description: "Enterprise AI driven SMS qualification system cutting manual sales effort by 70% with 16 stage HubSpot pipeline orchestration.",
    tech: ["HubSpot", "n8n", "GPT 5", "Sakari API", "Slack", "ClickFunnels"],
    github: "",
    live: ""
  },
  {
    title: "Hi ROOTS Real Estate Automation",
    category: "Automation",
    date: "Jul to Aug 2025",
    description: "End to end rental property management automation covering tenant journey from AI powered lead scoring to lease renewal automation.",
    tech: ["n8n", "Twilio", "GoHighLevel", "GPT 4", "MCP Server", "Airtable"],
    github: "",
    live: ""
  },
  {
    title: "Share The Truth Endorsements Outreach",
    category: "AI Outreach",
    date: "Aug to Sep 2025",
    description: "Advanced automated outreach system with AI powered prospect identification, hyper personalized email composition, and self improving optimization.",
    tech: ["n8n", "HubSpot", "Gemini", "Perplexity", "MCP Server"],
    github: "",
    live: ""
  },
  {
    title: "AI Viral Video Generation System",
    category: "Generative AI",
    date: "October 2025",
    description: "End to end automation for AI generated video content creation and multi platform social media distribution.",
    tech: ["n8n", "Sora 2", "Veo 3.1", "FAL.ai", "FFMPEG", "OpenAI"],
    github: "",
    live: ""
  },
  {
    title: "Autonomous Lead Conversion System",
    category: "AI Automation",
    date: "August 2025",
    description: "Autonomous lead conversion funnel with emotional AI decision engine classifying leads into 5 personas and dynamically assigning pricing tiers.",
    tech: ["Python", "n8n", "Apollo.io", "Apify", "GPT-4o", "Stripe"],
    github: "",
    live: ""
  },
  {
    title: "Chef Recruitment & Onboarding Funnel",
    category: "HR Automation",
    date: "July 2025",
    description: "Complete automation of chef applicant onboarding using AI voice screening, Mistral AI OCR certificate validation, cutting processing time by 70%.",
    tech: ["n8n", "VAPI", "Twilio", "Mistral AI OCR", "Google Sheets"],
    github: "",
    live: ""
  },
  {
    title: "Real Estate Data Pipeline",
    category: "Data Engineering",
    date: "Sep to Oct 2024",
    description: "End to end real estate data streaming pipeline scraping, processing, and visualizing property market insights at scale.",
    tech: ["Python", "Kafka", "Spark", "Cassandra", "Power BI"],
    github: "",
    live: ""
  },
  {
    title: "ADF Creative Marketer AI",
    category: "Sales AI",
    date: "Feb to Mar 2025",
    description: "AI powered sales automation system boosting 24/7 lead qualification by 40% with HubSpot CRM integration and automated Stripe payment processing.",
    tech: ["OpenAI API", "FastAPI", "HubSpot CRM", "Stripe", "PostgreSQL"],
    github: "",
    live: ""
  },
  {
    title: "Brain Tumor Detection",
    category: "ML",
    date: "Dec 2023 to Feb 2024",
    description: "CNN model achieving 99.2% accuracy for brain tumor detection from medical images, with FastAPI backend and React frontend.",
    tech: ["Python", "TensorFlow", "Keras", "FastAPI", "React"],
    github: "",
    live: ""
  }
];

export const experience = [
  {
    company: "Premier NX",
    role: "AI Engineer",
    date: "Feb 2026 to Present",
    location: "Remote, New Providence, NJ",
    points: [
      "Design and deploy production grade enterprise AI systems specializing in conversational voice agents on Amazon Connect using Nova Sonic, Q in Connect, and Bedrock AgentCore Gateway.",
      "Build custom Model Context Protocol (MCP) servers integrating AWS Lambda, external APIs, and RAG knowledge bases (AWS Bedrock with S3 vectors) for real time, uninterrupted multi agent orchestration and live data retrieval within a single voice session.",
      "Create end to end intelligent automation pipelines across AWS and Azure that embed RAG powered decision engines into Power Apps, Power Automate, and Logic Apps, unifying enterprise data sources and enabling scalable, production ready workflows for complex business decision making."
    ]
  },
  {
    company: "GetAiChatbots LLC",
    role: "AI Automation Engineer",
    date: "Dec 2024 to Feb 2026",
    location: "Remote, Miami, FL",
    points: [
      "Architected end to end AI automation solutions using Python, FastAPI, n8n, LangChain, and OpenAI with self learning pipelines for sentiment analysis",
      "Integrated complex ecosystems: Apollo.io, GoHighLevel, HubSpot, Salesforce, Zoho, Twilio, VAPI, ElevenLabs, and Stripe across AWS and Azure",
      "Built autonomous sales funnels processing 8,000+ prospects with emotional AI decision engines"
    ]
  },
  {
    company: "Moonsys Pvt. Ltd.",
    role: "Associate Software Engineer",
    date: "Jan 2024 to Dec 2024",
    location: "Lahore, Pakistan",
    points: [
      "Developed GPT Translator using OpenAI & Adobe APIs with Express.js backend, deployed on AWS (EC2, S3, Lambda, API Gateway)",
      "Built scalable microservices integrating FastAPI/Flask with Node.js/Express.js across MongoDB, MySQL, PostgreSQL",
      "Implemented OAuth 2.0 authentication and consumed RESTful APIs with OpenAI and Claude AI"
    ]
  },
  {
    company: "CodeBryx Technologies",
    role: "Software Engineering Intern",
    date: "Oct 2023 to Dec 2023",
    location: "Lahore, Pakistan",
    points: [
      "Built analytics portals using React.js and TypeScript",
      "Integrated REST APIs with Axios and React Query; migrated build system to Vite"
    ]
  },
  {
    company: "Skyscanner Pvt. Ltd.",
    role: "Frontend Developer Intern",
    date: "April 2023 to May 2023",
    location: "Remote",
    points: [
      "Built a web application using React.js as a front end engineer",
      "Developed a page for picking a travel date using Skyscanner’s open source Backpack React library",
      "Customised application and ran automated tests to ensure proper rendering"
    ]
  }
];

export const certifications = [
  {
    title: "Model Context Protocol: Advanced Topics",
    issuer: "Anthropic",
    date: "Issued May 2026",
    url: "https://verify.skilljar.com/c/5s53udks5hej"
  },
  {
    title: "Introduction to Model Context Protocol",
    issuer: "Anthropic",
    date: "Issued Mar 2026",
    url: "https://verify.skilljar.com/c/eytp3a6jebz3"
  },
  {
    title: "AWS DevOps",
    issuer: "Amazon Web Services (AWS)",
    date: "Issued Sep 2023",
    url: "https://www.coursera.org/account/accomplishments/specialization/certificate/JRBDQSTWJ47J"
  },
  {
    title: "AWS Beginner to Intermediate: EC2, IAM, ELB, ASG, Route 53",
    issuer: "Udemy",
    date: "Issued Oct 2024",
    url: "https://www.udemy.com/certificate/UC-c326fb3e-b2b0-4ab5-8110-0abb93232505/"
  },
  {
    title: "AWS Cloud Solution Architect: Prep",
    issuer: "Amazon Web Services (AWS)",
    date: "Issued Jul 2023",
    url: "https://www.coursera.org/account/accomplishments/professional-cert/EQDX5EFZ2NNH"
  },
  {
    title: "Machine Learning Specialization",
    issuer: "Stanford University",
    date: "Issued Jul 2023",
    url: "https://www.coursera.org/account/accomplishments/specialization/certificate/ZP4PU9RAZSVN"
  },
  {
    title: "Python-Introduction to Data Science and Machine learning A-Z",
    issuer: "Udemy",
    date: "Issued Mar 2024",
    url: "https://www.udemy.com/certificate/UC-40975fc8-4c90-493a-9a46-f87cf10ce87b/"
  },
  {
    title: "Advanced Foundations of Python Programming",
    issuer: "Udemy",
    date: "Issued Mar 2024",
    url: "https://www.udemy.com/certificate/UC-5bffd2b1-b8cc-490d-9da1-096093937cbe/"
  },
  {
    title: "IBM Backend Development",
    issuer: "IBM",
    date: "Issued Jan 2024",
    url: "https://www.coursera.org/account/accomplishments/specialization/certificate/NT4J4G3GBFQJ"
  },
  {
    title: "IBM Full Stack Software Developer",
    issuer: "IBM",
    date: "Issued Sep 2023",
    url: "https://www.coursera.org/account/accomplishments/specialization/certificate/GEABFA6GUMZ2"
  },
  {
    title: "Introduction to Agile Development and Scrum",
    issuer: "IBM",
    date: "Issued Feb 2023",
    url: "https://www.coursera.org/account/accomplishments/certificate/ECDFXN5CRRQS"
  },
  {
    title: "Samsung Innovation Campus - Artificial Intelligence Bootcamp",
    issuer: "Samsung Innovation Campus",
    date: "Issued Oct 2022",
    url: "https://drive.google.com/file/d/1UtDXAT4XLImlwredCu-XeMCt5WqhzIOo/view?usp=sharing"
  }
];

export const honorsAndAwards = [
  {
    title: "AWS Builders Online Series Completion",
    issuer: "Amazon Web Services",
    date: "Jan 2023",
    url: "https://drive.google.com/file/d/1CME31pshi1lVTBYIfgCX5q1zaCQm4tOv/view?usp=sharing"
  },
  {
    title: "Google Cloud & NVIDIA Community Member",
    issuer: "Google",
    date: "Sep 2025",
    url: "https://developers.google.com/profile/badges/nvidia-developer?u=usmanx191"
  },
  {
    title: "Google Cloud Innovators Get Certified 2025",
    issuer: "Google",
    date: "Sep 2025",
    url: "https://developers.google.com/profile/badges/community/innovators/cloud/getcertified2025?u=usmanx191"
  },
  {
    title: "Google Cloud Innovator Community Member",
    issuer: "Google",
    date: "Sep 2025",
    url: "https://developers.google.com/profile/badges/community/innovators/cloud/2021_member?u=usmanx191"
  },
  {
    title: "Discovered DevFest 2022",
    issuer: "Google",
    date: "Dec 2022",
    url: "https://developers.google.com/profile/badges/events/community/devfest/2022/discover?u=usmanx191"
  },
  {
    title: "Joined the Google Developer Program",
    issuer: "Google",
    date: "Dec 2022",
    url: "https://developers.google.com/profile/badges/profile/created-profile?u=usmanx191"
  },
  {
    title: "Google Developer Program premium tier",
    issuer: "Google",
    date: "Mar 2026",
    url: "https://developers.google.com/profile/badges/community/innovators/cloud/innovators_plus?u=usmanx191"
  },
  {
    title: "Samsung Innovation Campus - Artificial Intelligence Bootcamp",
    issuer: "Samsung",
    date: "Oct 2022",
    url: "https://drive.google.com/file/d/1UtDXAT4XLImlwredCu-XeMCt5WqhzIOo/view?usp=sharing"
  }
];
